var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.567 1.234 8.432 7.47c.164.205.287.45.287.656 0 .246-.123.492-.287.697l-5.865 6.235c-.37.41-.984.41-1.394.04-.41-.368-.41-.984-.041-1.394l5.25-5.578-5.25-5.537c-.37-.41-.37-1.025.04-1.395.41-.369 1.026-.369 1.395.041"
  })));
};
export default SvgChevronRight;